export default "__VITE_PUBLIC_ASSET__21276000__"